import React from 'react'

import { SxProps } from '@mui/material'

import Box from 'components_new/atoms/Box'
import NavigationItem from 'components_new/molecules/NavigationItem'

import { useGroup, useIsOwner, useMember } from 'redux/hooks/Groups'
import { useDashboardGroupsInGroup } from 'redux/hooks/DashboardGroups'
import { useParams } from 'utils/hooks'
import { useTranslation } from 'language/translator'
import { useAccountSettings } from 'redux/hooks/SignedInAccount'

interface GroupNavigationProps {
  sx?: SxProps
}

const GroupNavigation = (props: GroupNavigationProps) => {
  const { sx } = props
  const { id } = useParams()
  const { t } = useTranslation()

  const { allowAccess } = useAccountSettings()
  const group = useGroup(id)
  const groupMember = useMember(id)
  const isOwner = useIsOwner(id)
  const isLocked = group?.is_private && !groupMember && !isOwner
  const dashboardGroups = useDashboardGroupsInGroup(id)

  if (!group) return null

  const hasPending = isOwner && group.pending.length > 0
  const totalMembers = group.members.length + group.owners.length

  return (
    <>
      <Box sx={sx}>
        <NavigationItem
          item={{
            activePattern: `/groups/${id}`,
            href: `/groups/${id}`,
            icon: { name: 'Image' },
            title: t('global', 'overview')
          }}
        />
        {allowAccess.allow_key_metrics ? (
          <NavigationItem
            item={{
              activePattern: `/groups/${id}/tasks*`,
              disabled: isLocked,
              href: `/groups/${id}/tasks`,
              icon: { name: 'Tasks' },
              title: t('tasks', 'tasks')
            }}
          />
        ) : null}
        <NavigationItem
          item={{
            activePattern: `/groups/${id}/resources*`,
            disabled: isLocked,
            chip: {
              label: dashboardGroups.length
            },
            href: `/groups/${id}/resources`,
            icon: { name: 'Resources' },
            title: t('global', 'resources')
          }}
        />
        <NavigationItem
          item={{
            activePattern: `/groups/${id}/members*`,
            disabled: isLocked,
            chip: {
              color: hasPending ? 'success' : undefined,
              label: hasPending
                ? `${totalMembers} (${group.pending.length})`
                : totalMembers
            },
            href: `/groups/${id}/members`,
            icon: { name: 'Users' },
            title: t('global', 'members')
          }}
        />
        <NavigationItem
          item={{
            activePattern: `/groups/${id}/settings*`,
            disabled: !isOwner,
            href: `/groups/${id}/settings`,
            icon: { name: 'Settings' },
            title: t('global', 'settings')
          }}
        />
      </Box>
    </>
  )
}

export default GroupNavigation
